import {ControlledSelect, LabelRegular} from '@hm/fundamental'

import type {ImportPlantOption} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'

import {ExcelDropzone} from './ExcelDropzone'

type UploadStepProps = {
  needsPlantInput?: boolean
  plantId?: string
  siteName?: string
  plantOptions?: ImportPlantOption[]
  onPlantIdChange?: (value: string) => void
  onFileSelected: (file: File) => void
  isLoading: boolean
  plantInputValid: boolean
}

export const UploadStep = ({
  needsPlantInput,
  plantId,
  siteName,
  plantOptions,
  onPlantIdChange,
  onFileSelected,
  isLoading,
  plantInputValid
}: UploadStepProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <div className="flex flex-col gap-4">
      {needsPlantInput && (
        <>
          <ControlledSelect
            name="importPlantId"
            label={t('import.plantId')}
            value={plantId ?? ''}
            onChange={(value) => onPlantIdChange?.(String(value))}
            values={[
              {value: '', label: t('common.select')},
              ...(plantOptions?.map((option) => ({
                value: option.upmId,
                label: `${option.siteName} (${option.plantId})`
              })) ?? [])
            ]}
            data-cy="import-plant-id"
          />
          <LabelRegular className="text-foreground_faded" data-cy="import-site-name">
            {t('import.siteName')}: {siteName?.trim() ? siteName : '—'}
          </LabelRegular>
        </>
      )}
      <ExcelDropzone onFileSelected={onFileSelected} isLoading={isLoading || !plantInputValid} />
    </div>
  )
}
